/**
 * IXVerify v2 — graceful 501-stub degradation (ixv2 WP-2.3).
 *
 * Several v2 backend surfaces (studies, profiles) are 501 stubs until later
 * WPs. When a call answers 501 (`IXV_NOT_IMPLEMENTED`), pages render this
 * quiet card instead of an error: the page exists and is wired; the server
 * side simply hasn't landed yet.
 */
import { Hourglass } from 'lucide-react';
import { EmptyState } from '../../../ui';

export default function StubNotice({
  what,
  hint,
}: {
  /** What isn't served yet, e.g. "Study management". */
  what: string;
  hint?: string;
}) {
  return (
    <div data-testid="ixv-stub-notice">
      <EmptyState
        variant="card"
        icon={Hourglass}
        title={`${what} isn't available yet`}
        hint={
          hint ??
          'This part of IXVerify is still being rolled out. The page is ready and will light up as soon as the service ships.'
        }
      />
    </div>
  );
}
